/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_2_TitleInputs */

const en_terms_section_2_title = /** @type {(inputs: Terms_Section_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Definitions`)
};

const lv_terms_section_2_title = /** @type {(inputs: Terms_Section_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Definīcijas`)
};

/**
* | output |
* | --- |
* | "2. Definitions" |
*
* @param {Terms_Section_2_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_2_title = /** @type {((inputs?: Terms_Section_2_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_2_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_2_title(inputs)
	return en_terms_section_2_title(inputs)
});